const FormData = require('form-data');

const { API_URL, RETRY_TIMEOUT } = {
  // API_URL: 'https://apidev.enface.io',
  API_URL: 'https://api.enface.ai',
  RETRY_TIMEOUT: 1,
};
console.log({ API_URL });

const sleep = m => new Promise(r => setTimeout(r, m));

const apiRequest = async ({ uri, post }) => {
  let result = await fetch(`${API_URL}/v1${uri}`, {
    method: 'POST',
    body: post,
    // headers: { 'Content-Type': 'multipart/form-data' },
  });
  let response;
  try {
    response = await result.text();
    result = JSON.parse(response);
    if (result.status === 'error') {
      console.error('[apiRequest] error response', response);
      return result;
    }
    return result;
  } catch (error) {
    console.error('[apiRequest] bad response', response);
    throw new Error(`Bad response: ${error}`);
  }
};

const apiProcess = async (uri, post) => {
  try {
    const result = await apiRequest({ uri, post });
    if (result.status === 'error' && result.message.startsWith('IMQP queue')) {
      throw new Error(result.message);
    }
    return result;
  } catch (error) {
    console.error('[apiRequest] failed', error);
    throw error;
  }
};

export const apiLivenessStart = params => {
  const form = new FormData();
  params.project_id && form.append('project_id', params.project_id);
  params.session_id && form.append('session_id', params.session_id);
  params.group_id && form.append('group_id', params.group_id);
  params.source_id && form.append('source_id', params.source_id);
  form.append('image', new Blob([params.image], { type: 'image/jpg' }), '0.jpg');
  return apiProcess('/livenessweb/create', form);
};

export const apiGuaranted = async (func, params) => {
  let result = null;
  do {
    try {
      result = await func(params);
    } catch (error) {
      console.error(`[apiGuaranted] exception, waiting [${RETRY_TIMEOUT}] to retry`, { error: error.stack || error.mesage });
      await sleep(RETRY_TIMEOUT);
    }
  } while (result === null);
  return result;
};
